export default __webpack_public_path__ + "static/media/Invalid.b91f9136.svg";